(() => {
  const SELECTOR = '[data-cs-product-spotlight]';

  function initSpotlight(section) {
    if (!section || section.dataset.csSpotlightReady === 'true') return;

    const button = section.querySelector('[data-cs-spotlight-add]');
    const status = section.querySelector('[data-cs-spotlight-status]');

    if (!button) return;

    section.dataset.csSpotlightReady = 'true';

    const resetButton = () => {
      button.disabled = false;
      button.textContent =
        button.dataset.defaultLabel ||
        'Add to my order';
    };

    button.addEventListener('click', async () => {
      if (button.disabled) return;

      const variantId = Number(button.dataset.variantId);
      const orderMode = String(button.dataset.orderMode || '')
        .trim()
        .toLowerCase();

      const shopUrl =
        button.dataset.shopUrl ||
        '/pages/about-us?view=shop&mode=local&gateway=skip';

      if (!variantId) {
        if (status) {
          status.textContent =
            'This bake is temporarily unavailable.';
        }
        return;
      }

      if (!orderMode) {
        if (status) {
          status.textContent =
            'This bake needs its Cold Sugar order type configured before it can be added.';
        }
        return;
      }

      button.disabled = true;
      button.textContent = 'Adding…';

      if (status) {
        status.textContent = '';
      }

      try {
        /*
         * Use Cold Sugar's existing sitewide protection first.
         * This prevents local and shipped products from being
         * silently mixed in the same cart.
         */
        if (
          !window.ColdSugarOrderMode ||
          typeof window.ColdSugarOrderMode.beforeAdd !== 'function'
        ) {
          throw new Error(
            'Order protection is still loading. Please wait a moment and try again.'
          );
        }

        const allowed =
          await window.ColdSugarOrderMode.beforeAdd({
            orderMode,
            trigger: button
          });

        /*
         * Customer chose to keep the existing incompatible cart.
         */
        if (!allowed) {
          resetButton();
          return;
        }

        const root =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _cold_sugar_order_mode: orderMode
                }
              }
            ]
          })
        });

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
            result.message ||
            'We couldn’t add this bake right now.'
          );
        }

        button.textContent = 'Added ✓';

        if (status) {
          status.textContent =
            'Added to your order. Taking you to the shop…';
        }

        window.setTimeout(() => {
          window.location.assign(shopUrl);
        }, 500);
      } catch (error) {
        console.error(
          'Cold Sugar spotlight add failed:',
          error
        );

        resetButton();

        if (status) {
          status.textContent =
            error?.message ||
            'We couldn’t add this bake right now. Please try again.';
        }
      }
    });
  }

  function initAll(root = document) {
    if (root.matches?.(SELECTOR)) {
      initSpotlight(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach(initSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }

  /*
   * Reinitialize when Shopify reloads this section
   * inside the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => initAll(event.target)
  );
})();
